import api from 'api/apiInstance';

export function clientCaseReviewApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
